import { render, staticRenderFns } from "./TxContent.vue?vue&type=template&id=70b45837&scoped=true&"
import script from "./TxContent.vue?vue&type=script&lang=js&"
export * from "./TxContent.vue?vue&type=script&lang=js&"
import style0 from "./TxContent.vue?vue&type=style&index=0&id=70b45837&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b45837",
  null
  
)

export default component.exports